import { defineAsyncComponent } from 'vue';

import { legacyReportRedirectGuard } from '@/components/core/analytics/utils/report-route-guards';
import { constants } from '@/config';

const App = () => import('@/app/threads/App.vue');
const Overview = () => import('@/app/threads/pages/Overview.vue');
const AnalyticsYourPostsPage = defineAsyncComponent(
  () => import('@/components/core/analytics/AnalyticsYourPostsPage.vue'),
);
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');

const PAGE_LEVEL_TOP = 'Threads';

export default {
  path: 'threads',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'threads',
      path: '',
      redirect: { name: 'threads.overview' },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'threads.overview',
      path: 'overview',
      component: Overview,
      props: { key: constants.THREADS },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'threads.overview.report',
      path: 'overview/report',
      component: Overview,
      props: { key: constants.THREADS },
      beforeEnter: legacyReportRedirectGuard,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      name: 'threads.yourPosts',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.THREADS,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'threads.yourPosts.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.THREADS,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'threads.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.THREADS,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Boards`,
          },
        },
      ],
    },
  ],
};
